import { Empty } from "antd";
import { __ } from "../../locales/translation";

export const EmptyInstrumentTable = () => {
    return (
        <Empty
            description={__("No hay resultados")}
        />
    );
}